<template>
  <div v-for="i in small ? 3 : 5" :key="`skeleton-${i}`" class="row q-px-sm q-py-lg">
    <div class="col-2 q-mr-lg flex justify-end">
      <q-skeleton width="100px" height="15px" />
    </div>
    <div class="col-grow q-gutter-y-sm">
      <div class="col-2 q-mt-xs q-mr-lg flex justify-start items-center q-gutter-x-md">
        <q-skeleton width="200px" height="25px" />
      </div>
      <q-skeleton height="300px" />
    </div>
  </div>
</template>

<script setup>
  defineProps({
    small: Boolean
  })
</script>
